export default "__VITE_ASSET__Ca2cEJ8o__"